import React, { useRef } from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

import { sendUploadPostImageEvent } from 'constants/mixpanelHelper';

export default function ImageUpload({ disabled, icon, setFile, accept = 'image/*' }) {
  const fileInputRef = useRef(null);

  function onFileChange(event) {
    // setFile(event.target.files[0]);
    setFile(event.target.files[0]);
    event.target.value = '';
  }
  function onIconClick() {
    sendUploadPostImageEvent();
    fileInputRef.current.click();
  }

  return (
    <div>
      <ImageUploadInput
        ref={fileInputRef}
        id="fileInput"
        onChange={onFileChange}
        type="file"
        accept={accept}
        disabled={disabled}
      />
      <span onClick={onIconClick}>{icon}</span>
    </div>
  );
}

const ImageUploadInput = styled.input`
  opacity: 0;
  position: absolute;
  pointer-events: none;
  width: 1px;
  height: 1px;
`;

ImageUpload.propTypes = {
  setFile: PropTypes.func.isRequired,
};
